
export default {
    name: 'modifyTeacher',
    title: '老师信息修改',
    component: () => import('../../../views/dialog/ModifyTeacher')
}
